import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MATERIAL_IMPORTS } from '../../../material/material-imports';
import { FormControl } from '@angular/forms';

import { of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

import { ProblemModel } from '@generativ/much-smarter-models';
import { Observable } from 'rxjs';

@Component({
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, ...MATERIAL_IMPORTS],
  selector: 'app-problem-auto-complete',
  templateUrl: './problem-auto-complete.component.html',
  styleUrls: ['./problem-auto-complete.component.scss']
})
export class ProblemAutoCompleteComponent implements OnInit {

  problemCtrl: FormControl;
  @Input() initialValue: string;
  @Input() keepValue = false;
  @Input() hasMore = false;
  @Input() problems: ProblemModel[];
  @Output() onProblemSelect = new EventEmitter<ProblemModel>();
  @Output() onLoadMore = new EventEmitter<any>();
  @Output() onQueryChange = new EventEmitter<string>();


  constructor() {
    this.problemCtrl = new FormControl();
  }

  ngOnInit() {
    this.problemCtrl.setValue(this.initialValue ? this.initialValue : '');
    // Subscribe to changes on the problem  ctrl form.
    // Once it changes we emit the event of changing the keyword for updating the problems
    this.problemCtrl.valueChanges.pipe(
      startWith(this.problemCtrl.value)).subscribe(() => {
      this.onQueryChange.emit(this.problemCtrl.value);
    });
  }

  setProblem(problem: ProblemModel, removeValue = false) {
    this.onProblemSelect.emit(problem);
    if (!this.keepValue) {
      this.problemCtrl.setValue('');
    }
  }

  clearProblemValue() {
    this.problemCtrl.setValue('');
    this.onQueryChange.emit(null);
    this.onProblemSelect.emit(null);
  }

  loadMore() {
    this.onLoadMore.emit(null);
  }
}
